import { useSelector } from "react-redux";

// Redux
import {
  getCurrentStatusIsOpenForDelivery,
  getDeliveryServiceArea,
} from "redux/selectors/cartDispensary";
import { formatMaxTimeEstimate } from "utils/formatMaxTimeEstimate";

const DeliveryTimeEstimate = () => {
  const isOpenForDelivery = useSelector(getCurrentStatusIsOpenForDelivery);
  const deliveryServiceArea = useSelector(getDeliveryServiceArea);

  if (
    !isOpenForDelivery ||
    !deliveryServiceArea ||
    !deliveryServiceArea.deliveryDurationMaximum
  ) {
    return null;
  }

  const message = formatMaxTimeEstimate(
    Number(deliveryServiceArea.deliveryDurationMaximum),
    "verbose"
  );

  return (
    <div
      data-testid="delivery-time-estimate"
      className="my-sm text-xs font-bold"
    >
      <span>{message}</span>
    </div>
  );
};

export default DeliveryTimeEstimate;
